@if (value() === true) {
  <span>
    {{ 'common.yes' | translate }}
  </span>
} @else if (value() === false) {
  <span>
    {{ 'common.no' | translate }}
  </span>
} @else if (value() === null || value() === undefined) {
  <span> - </span>
}
